var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item any-fn"},[_c('SwiperBox',{attrs:{"tabs":_vm.list,"options":_vm.options}},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"swiper-slide"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.img_url),expression:"item.img_url"}]})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }